import React from "react"
import autobind from "class-autobind"
import ImageLoader from "../misc/ImageLoader"
import Paper from "material-ui/Paper"
import { amber500 } from "material-ui/styles/colors"

interface IProps {
    disabled: boolean
    picture: any
    selected?: boolean
    imageUrlPropertyName?: string
    imageFixedHeight?: number
    handleChangeSelect?(): void
    handleDelete?(): void
    handleSetDefaultPic?(): void
}
interface IState {
    hovering: boolean
}

export default class PictureTile extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super()
        this.state = {
            hovering: false
        }
        autobind(this)
    }

    handleMouseOver() {
        !this.props.disabled &&
            this.setState({ hovering: true })
    }

    handleMouseOut() {
        !this.props.disabled &&
            this.setState({ hovering: false })
    }

    handleSelect() {
        !this.props.disabled && this.props.handleChangeSelect &&
            this.props.handleChangeSelect()
    }

    onDelete() {
        !this.props.disabled &&
            this.props.handleDelete()
    }

    handleSetDefaultPic() {
        !this.props.disabled &&
            this.props.handleSetDefaultPic()
    }

    render() {
        const isActive = this.state.hovering || this.props.selected
        const opacityOverlay = isActive ? 0.3 : 0
        const opacityCircle = isActive ? 1 : 0
        return (
            <Paper zDepth={2} style={{ position: "relative" }}>
                <ImageLoader url={this.props.imageUrlPropertyName ? this.props.picture[this.props.imageUrlPropertyName] : this.props.picture.ImageS3Url} fixedHeight={this.props.imageFixedHeight || 300} />
                <div style={{ position: "absolute", left: 0, top: 0, width: "100%", height: "100%" }}>
                    <div
                        style={{ position: "absolute", left: 0, top: 0, width: "100%", height: "100%", background: amber500, opacity: opacityOverlay, cursor: this.props.disabled ? "" : "pointer" }}
                        onClick={this.handleSelect}
                        onMouseOver={this.handleMouseOver}
                        onMouseOut={this.handleMouseOut}
                    />
                    {!this.props.disabled && this.props.handleChangeSelect &&
                        <span
                            className="fa-stack fa-lg"
                            style={{ display: "block", padding: 5, cursor: "pointer", opacity: opacityCircle }}
                            onMouseOver={this.handleMouseOver}
                            onMouseOut={this.handleMouseOut}
                            onClick={this.handleSelect}
                        >
                            <i className="fa fa-circle fa-stack-2x" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} style={{ cursor: "pointer", color: "#333333" }} />
                            {this.props.selected &&
                                <i
                                    className="fa fa-check fa-stack-1x fa-inverse"
                                    onMouseOver={this.handleMouseOver}
                                    onMouseOut={this.handleMouseOut}
                                    style={{ cursor: "pointer", display: "inline-block" }}
                                />
                            }
                        </span>
                    }
                    {!this.props.disabled && this.props.handleSetDefaultPic &&
                        <div
                            style={{ color: "#ffffff", position: "absolute", right: 30, top: 0, padding: 10, display: isActive, fontSize: 22, cursor: "pointer" }}
                            onMouseOver={this.handleMouseOver}
                            onMouseOut={this.handleMouseOut}
                            onClick={this.handleSetDefaultPic}
                        >
                            <i className="fa fa-user" />
                        </div>
                    }
                    {!this.props.disabled && this.props.handleDelete &&
                        <div
                            data-intercom-target={"menu-Picture-Tile-Delete"}
                            style={{ color: "#ffffff", position: "absolute", right: 0, top: 0, padding: 10, display: isActive, fontSize: 22, cursor: "pointer" }}
                            onMouseOver={this.handleMouseOver}
                            onMouseOut={this.handleMouseOut}
                            onClick={this.onDelete}
                        >
                            <i className="fa fa-trash" />
                        </div>
                    }
                </div>
            </Paper>
        )
    }
}
